import { useState } from "react";
import { useAddAccessControlMutation } from "../../../store/apiSlices/accessControl";

export default function AccessControlInput({ tableId }: { tableId: number }) {
  const [email, setEmail] = useState("");
  const [role, setRole] = useState<"viewer" | "editor">("editor");

  const [addAccessControl] = useAddAccessControlMutation();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!email.trim()) return;

    console.log(email, tableId);

    const payload = {
      email,
      table_id: tableId,
      shared: role,
    };

    await addAccessControl(payload);

    setEmail(""); // clear after submit
  };

  return (
    <form onSubmit={handleSubmit} className="flex items-center gap-3">
      <div className="flex items-center border border-gray-300 rounded-xl px-3 py-2 w-full bg-white">
        <input
          type="email"
          placeholder="Enter email to share…"
          className="flex-1 outline-none bg-transparent pr-3"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        {/* Divider */}
        <div className="h-5 w-px bg-gray-300 mx-2"></div>

        {/* Role select */}
        <select
          value={role}
          onChange={(e) => setRole(e.target.value as any)}
          className="bg-transparent outline-none text-gray-700"
        >
          <option value="viewer">Viewer</option>
          <option value="editor">Editor</option>
        </select>
      </div>

      <button
        type="submit"
        className="px-4 py-2 bg-custom-blue-medium text-white rounded-lg hover:opacity-70 disabled:bg-gray-400 cursor-pointer"
        disabled={!email.trim()}
      >
        Share
      </button>
    </form>
  );
}
